<template>
  <div id="scroll-board">
    <dv-scroll-board :config="config"/>
  </div>
</template>

<script>
  import { mapState } from 'vuex'

  export default {
    name: 'ScwlWaybillScrollBoard',
    computed: {
      ...mapState('bigScreenData', ['waybillList'])
    },
    watch: {
      waybillList (val, old) {
        let data = []
        for (let li of val) {
          let item = [li.clientName, li.clientName, li.waybillNo, li.distributionDate, li.driverName + li.driverUsername, li.vehicleNo]
          data.push(item)
        }
        this.config = {
          header: ['货主名称', '运单归属', '运单编号', '发车日期', '司机信息', '车牌号'],
          data: data,
          // index: true,
          columnWidth: [180, 120, 220, 120, 180, 120,],
          align: ['left'],
          rowNum: 5,
          headerBGC: 'rgba(5,22,65,0.76)',
          headerHeight: 30,
          oddRowBGC: 'rgba(0, 44, 81, 0.8)',
          evenRowBGC: 'rgba(10, 29, 50, 0.8)'
        }
      },
    },
    data () {
      return {
        config: {
          header: ['货主名称', '运单归属', '运单编号', '发车日期', '司机信息', '车牌号'],
          data: [],
          // index: true,
          columnWidth: [120, 120, 120, 120, 120, 120,],
          align: ['left'],
          rowNum: 10,
          headerBGC: 'rgba(5,22,65,0.76)',
          headerHeight: 30,
          oddRowBGC: 'rgba(0, 44, 81, 0.8)',
          evenRowBGC: 'rgba(10, 29, 50, 0.8)'
        }
      }
    }
  }
</script>

<style lang="less">
  #scroll-board {
    width: 100%;
    box-sizing: border-box;
    margin-left: 20px;
    height: 100%;
    overflow: hidden;
  }
</style>
